import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class PartCode extends Component {
  constructor(props) {
    super(props);
    this.handlePartCodeChange = this.handlePartCodeChange.bind(this);
    this.handleWatchPart = this.handleWatchPart.bind(this);
    this.handlePartCodeBlur = this.handlePartCodeBlur.bind(this);
  }

  checkRepeatedCodes(orderDetail, currentIndex, partCode) {
    return orderDetail.findIndex((element, index) => element.partCode === partCode && index !== currentIndex);
  }
  
  handlePartCodeBlur() {
    const {provider, orderType, detail, partCode, index} = this.props;
    const repeatedCodeIndex = this.checkRepeatedCodes(detail, index, partCode);

    if (partCode && repeatedCodeIndex !== -1) {
      this.props.addMessageBoxError(`El código ya está incluido en la línea ${repeatedCodeIndex + 1} del pedido`);
      return;
    }

    if (partCode) {
      this.props.checkProviderStockOrderCode(
        {partCode},
        {provider, 'type': index},
        {'partType': orderType});
    }
  }

  handlePartCodeChange(event, data) {
    const {index} = this.props;

    this.props.editProviderManualOrderElementCode(index, data.value.trim().toUpperCase());
  }

  handleWatchPart() {
    const {partCode, partName} = this.props;

    this.props.showOrderPartDetails(partCode, partName);
  }

  render() {
    const {partCode} = this.props;

    return (
      <Input required
        autoFocus={!partCode}
        className='input-part-code'
        size='mini'
        name='partCode'
        maxLength='20'
        value={partCode}
        placeholder='Código'
        onFocus={this.handleWatchPart}
        onBlur={this.handlePartCodeBlur}
        onChange={this.handlePartCodeChange}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  'detail': state.providerManualOrder.detail,
  'provider': state.providerManualOrder.provider,
  'orderType': state.providerManualOrder.orderType,
});

const {
  addMessageBoxError,
  checkProviderStockOrderCode,
  editProviderManualOrderElementCode,
  showOrderPartDetails,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  checkProviderStockOrderCode,
  editProviderManualOrderElementCode,
  showOrderPartDetails,
})(PartCode);
